<mat-card appearance="outlined">
    <mat-card-header>
        <mat-card-title>Quick Links</mat-card-title>
    </mat-card-header>

    <mat-card-content fxLayout="column" fxLayoutAlign="space-between stretch">
        <busy-indicator *ngIf="!isLoaded" chart="true"></busy-indicator>

        <ng-container *ngIf="isLoaded">
            <div *ngFor="let row of rows" class="row">
                <div *ngFor="let link of row" fxFlex="50">
                    <a (click)="onLinkClicked(link.Link)" [attr.telemetry]="getAriaLabel(link)">
                        {{link.Name}}
                    </a>
                </div>
            </div>

            <div [fxShow]="!chartHasData">There are no quick links</div>
        </ng-container>
    </mat-card-content>

</mat-card>